/**
 * Asf — Apparent Spacing Factor (Algorithm_Additional Xlog3D_Asf_10Aug26).
 *
 * Inclination is positive for a tunnel falling along D and negative when
 * rising. The inclination term subtracts for apDirTrue = D and adds for
 * apDirTrue = Dopp. apDirTrue is the horizontal-reference apparent dip
 * direction, captured BEFORE the plotting inclination adjustment flips ApDir.
 *
 * Geometrically Asf = |n . t| (plane unit normal dotted with the tunnel axis
 * unit vector), so 0 <= Asf <= 1. Apparent Spacing along the tunnel =
 * True Spacing / Asf.
 */

const toRadians = (angle) => angle * (Math.PI / 180);

export function computeAsf({ amt, alpha, inclination, apDirTrue, dopp }) {
  const I = apDirTrue === dopp ? inclination : -inclination;
  return Math.abs(
    Math.sin(toRadians(amt)) * Math.cos(toRadians(I)) * Math.sin(toRadians(alpha)) +
    Math.cos(toRadians(amt)) * Math.sin(toRadians(I))
  );
}

/**
 * Asf for a vertical shaft: the axis is vertical, so |n . t| is the vertical
 * component of the plane's normal, sin(90 - Amt).
 */
export const shaftAsf = (amt) => Math.sin(toRadians(90 - Number(amt)));

/** Asf as the Outputs tables print it: two decimals, trailing zeros dropped. */
export const formatAsf = (asf) => Number(asf).toFixed(2).replace(/\.?0+$/, "");
